module.exports = __webpack_public_path__ + "media/pages/Contact/afm_wechat-b7fc60fe96cad48af31926833398270d.jpeg";